import { useTranslation } from "react-i18next";
import { cn } from "@/core/helpers/cn";
import { Button, Modal } from "@/shared/ui";
import { ModalProps } from "@/shared/ui/modal/Modal";

type Props = ModalProps & {
  i18FileName: string;
  dataMzAccent?: string;
  classNameOverlay?: string;
};

export default function PayRulesModal({
  i18FileName,
  dataMzAccent,
  classNameOverlay,
  ...props
}: Props) {
  const { t } = useTranslation(i18FileName);

  return (
    <Modal
      {...props}
      title={t(`${i18FileName}.fee.rules.title`)}
      classNameOverlay={cn("absolute", classNameOverlay)}
      className="w-[31.25rem]"
      classNameCloseBtn="size-7"
    >
      <div className="flex flex-col gap-3.5" data-mz-accent={dataMzAccent}>
        <div className="text-15 font-medium text-white/50">
          {t(`${i18FileName}.fee.rules.description.1`)}
        </div>
        <div className="text-14 font-medium text-[#FF9E58] bg-gradient-to-r from-[#FF9E58]/15 to-[#FF9E58]/5 p-4 rounded-[0.5rem]">
          {t(`${i18FileName}.fee.rules.description.2`)}
        </div>
        <Button onClick={props?.onClose} className="h-11">
          {t(`${i18FileName}.fee.rules.button`)}
        </Button>
      </div>
    </Modal>
  );
}
